import { fr, enGB, es, pt } from "date-fns/locale";

// Map the app language code to a BCP-47 locale (for Intl) and a date-fns locale.
const BCP47 = { fr: "fr-FR", en: "en-GB", es: "es-ES", pt: "pt-PT" };
const DFNS = { fr, en: enGB, es, pt };

export const localeFor = (lang) => BCP47[lang] || "fr-FR";
export const dfnsLocale = (lang) => DFNS[lang] || fr;

// "DÉC" / "DEC" / "DIC" / "DEZ" — localized short month, upper-cased, no trailing dot.
export const monthShort = (date, lang) =>
  new Date(date).toLocaleDateString(localeFor(lang), { month: "short" }).replace(/\.$/, "").toUpperCase();

export const fmtEventDate = (date, lang) =>
  new Date(date).toLocaleDateString(localeFor(lang), { weekday: "long", day: "numeric", month: "long" });

export const fmtTime = (date, lang) =>
  new Date(date).toLocaleTimeString(localeFor(lang), { hour: "2-digit", minute: "2-digit" });

// Local YYYY-MM-DD (avoids the UTC shift of toISOString()).
export const toYMD = (d) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Live countdown label for an event card → makes it feel urgent & inviting.
// Returns { label, urgent } or null when the event has already started.
export const countdownInfo = (date, t) => {
  const ms = new Date(date).getTime() - Date.now();
  if (ms <= 0) return null;
  const mins = Math.floor(ms / 60000), hrs = Math.floor(mins / 60), days = Math.floor(hrs / 24);
  if (days >= 1) return { label: t("events.cd_days", "Dans {n} j").replace("{n}", days), urgent: false };
  if (hrs >= 1) return { label: t("events.cd_hours", "Dans {n} h").replace("{n}", hrs), urgent: hrs < 3 };
  if (mins >= 1) return { label: t("events.cd_mins", "Dans {n} min").replace("{n}", mins), urgent: true };
  return { label: t("events.cd_soon", "Commence bientôt"), urgent: true };
};
